<section class="mat-typography mat-body component-container">
  <form [formGroup]="form" (ngSubmit)="sendEmail()">
    <div class="inputs">

      <!--to -->
      <mat-form-field appearance="outline">
        <mat-label>Recipient's Email:</mat-label>
        <input matInput formControlName="to" required/>
        @if (form.controls.to.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>

      <!-- <br/> -->

      <!-- from -->
      <!-- <mat-form-field appearance="outline">
      <mat-label>From:</mat-label>
      <input matInput formControlName="from" required/>
      <mat-error *ngIf="form.controls.from.errors?.required">Required</mat-error>
    </mat-form-field> -->
  </div>
  <ng-container>
    <div class="">
      <button mat-raised-button class="button-margin" color="primary" type="submit">Send Email</button>
      <button mat-raised-button color="secondary" type="button" (click)="closeModal()">Cancel</button>
    </div>
  </ng-container>
</form>
</section>
